import * as React from 'react';

export const withQuery = mapDataToProps => Component => ({ data, ...rest }) =>
  <Component {...mapDataToProps(data)} {...rest}/>;
